import Axios from 'axios';
import ApiUtils from './api-utils';
import { pickBy } from 'lodash';

export default {
  getHistoriqueLivraisons: (numTiers, dateFin) => {
    const params = pickBy({ dateFin }, i => i !== undefined);
    return ApiUtils.responseParser(Axios.get('/web/v1/tiers/' + numTiers + '/livraisons', { params }));
  },
  getCommandesEncours: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/tiers/' + numTiers + '/commandes/commandes-en-cours')),
  getCommandes: (numTiers, etapes, dateDebut, dateFin) => {
    const params = pickBy({
      etapes: (etapes ? etapes.join(',') : null),
      dateDebut,
      dateFin

    }, i => i !== undefined);

    return ApiUtils.responseParser(Axios.get(`/web/v1/tiers/${numTiers}/commandes`, { params }));
  },
  envoyerCommande: (numTiers, commande) => ApiUtils.responseParser(Axios.post(`/web/v1/tiers/${numTiers}/commandes`, commande))

};
